export const UPDATE_CONTACT = 'UPDATE_CONTACT';
export const UPDATE_PLAN_DETAILS = 'UPDATE_PLAN_DETAILS';
export const UPDATE_PROVINCE = 'UPDATE_PROVINCE';
export const UPDATE_LOADER = 'UPDATE_LOADER';
export const UPDATE_AGREED_TO_TERMS = 'UPDATE_AGREED_TO_TERMS';
export const UPDATE_MODAL_TO_SHOW = 'UPDATE_MODAL_TO_SHOW';
export const UPDATE_RECAPTCHA = 'UPDATE_RECAPTCHA';

export const updateContact = ({ field = '', value = {} } = {}) => ({ type: UPDATE_CONTACT, ...(field && { field, value }) });

export const updatePlanDetails = ({ data = {} } = {}) => ({
  type: UPDATE_PLAN_DETAILS,
  ...(Object.keys(data).length && { data }),
});

export const updateProvince = ({
  provinceCode = null,
  value = null,
  valid = undefined,
  disabled = false,
} = {}) => ({
  type: UPDATE_PROVINCE,
  data: {
    provinceCode, value, valid, disabled,
  },
});

export const updateLoader = ({ show = false } = {}) => ({ type: UPDATE_LOADER, show });

export const updateAgreedToTerms = ({
  agreed = false,
  showToolTip = false,
} = {}) => ({ type: UPDATE_AGREED_TO_TERMS, agreed, showToolTip });

export const updateModalsView = ({
  view = undefined,
  message = undefined,
  editPlan = false,
} = {}) => ({
  type: UPDATE_MODAL_TO_SHOW, view, message, editPlan,
});

export const updateRecaptcha = ({ data = {} } = {}) => ({
  type: UPDATE_RECAPTCHA,
  ...(Object.keys(data).length && { data }),
});
